export default __webpack_public_path__ + "static/media/t6.min.5b3394c3.png";